export const SECTIONS_WITH_ASSETS_FILTER = [
  "apps",
  "compute",
  "datasets",
  "alerts",
  "dashboard",
  "runs",
  "task",
] as const;

export const SECTIONS_WITH_TAGS_AND_OWNERS_FILTERS = [
  "apps",
  "alerts",
  "dashboard",
  "runs",
  "datasets",
  "compute",
] as const;

export const SECTIONS_WITH_TIME_WINDOW_FILTER = [
  "apps",
  "datasets",
  "alerts",
  "dashboard",
  "runs",
  "compute",
] as const;
